<script>
// 与后端同域部署（nginx 反向代理），API 与 WebSocket 均使用当前访问的域名
const BASE_URL = '/'
const UPLOAD_URL = '/'
const WEBSOCKET_URL = window.location.host + '/'
export default {
  BASE_URL,
  UPLOAD_URL,
  WEBSOCKET_URL
}
</script>



// WEBPACK FOOTER //
// src/Base.vue